// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2y6hx";
var _4 = "row-IPYzK";
var _5 = "name_wrapper-3U9Aa";
var _6 = "number-rUBJ3";
var _7 = "number_offset-ZFVLN";
var _8 = "name-3tIp-";
var _9 = "counter_wrapper-2gg2f";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "row", _5 as "name_wrapper", _6 as "number", _7 as "number_offset", _8 as "name", _9 as "counter_wrapper" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "row": _4, "name_wrapper": _5, "number": _6, "number_offset": _7, "name": _8, "counter_wrapper": _9 }
